<template>
  <q-card flat :style="$q.screen.lt.md?'':'min-width:500px'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        {{ `گزارش خرید و فروش ${goodsInfo.Goods_Name} در سال جاری` }}
        <template v-slot:action>
          <q-btn round icon="close" v-close-popup flat/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-table
          flat bordered
          :pagination="pagination"
          :data="items"
          :hide-header="$q.screen.lt.md"
          :columns="columns"
          row-key="Month">
        <template v-slot:body="props" >
          <q-tr :props="props" v-if="!$q.screen.lt.md">
            <q-td key="Month" :props="props">
              {{ props.row.Month }}
            </q-td>
            <q-td key="Sale_Pay" :props="props">
              <q-badge color="green">
                {{props.row.Sale_Pay? props.row.Sale_Pay.toLocaleString() : 0 }}
              </q-badge>
            </q-td>
            <q-td key="SaleG_Count" :props="props">
              <q-badge color="purple">
                {{ props.row.SaleG_Count? props.row.SaleG_Count:0 }}
              </q-badge>
            </q-td>
            <q-td key="Buy_Pay" :props="props">
              <q-badge color="orange">
                {{ props.row.Buy_Pay?props.row.Buy_Pay.toLocaleString():0 }}
              </q-badge>
            </q-td>
            <q-td key="BuyG_Count" :props="props">
              <q-badge color="primary">
                {{ props.row.BuyG_Count ? props.row.BuyG_Count : 0 }}
              </q-badge>
            </q-td>
          </q-tr>
          <q-tr :props="props" v-if="$q.screen.lt.md">
            <q-td key="Month" :props="props">
              <q-chip color="indigo" square class="q-ml-xs" text-color="white" :label="props.row.Month" />
            </q-td>
            <q-td key="Sale_Pay" :props="props">
              <q-card flat>
                <q-card-section class="text-left no-padding">
                  <q-chip square label="مبلغ فروش" color="indigo" text-color="white">
                    <q-badge color="red" class="q-ml-xs" text-color="white" :label="(props.row.Sale_Pay?props.row.Sale_Pay.toLocaleString():0)" />
                  </q-chip>
                  <q-space/>
                  <q-chip square label="تعداد فروش" color="indigo" text-color="white">
                    <q-badge color="red" class="q-ml-xs" text-color="white" :label="(props.row.SaleG_Count?props.row.SaleG_Count:0)" />
                  </q-chip>
                  <q-separator />
                </q-card-section>
                <q-card-section class="text-left no-padding">
                  <q-chip square label="مبلغ خرید" color="indigo-10" text-color="white">
                    <q-badge color="red" class="q-ml-xs" text-color="white" :label="(props.row.Buy_Pay?props.row.Buy_Pay.toLocaleString():0)" />
                  </q-chip>
                  <q-space/>
                  <q-chip square label="تعداد خرید" color="indigo-10" text-color="white">
                    <q-badge color="red" class="q-ml-xs" text-color="white" :label="(props.row.BuyG_Count?props.row.BuyG_Count:0)" />
                  </q-chip>

                </q-card-section>
              </q-card>
            </q-td>
          </q-tr>

        </template>
      </q-table>
    </q-card-section>
  </q-card>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: 'GoodsBuySaleInYearReport',
  components: {},
  props: {
    goodsInfo: {
      type: Object,
      default: () => undefined,
      required: true
    }
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 12
      },
      columns: [
        {
          name: 'Month',
          label: 'ماه',
          align: 'center',
          field: row => row.Month,
          sortable: true
        },
        {
          name: 'Sale_Pay',
          label: 'فروش',
          align: 'center',
          field: row => row.Sale_Pay,
          sortable: true
        },
        {
          name: 'SaleG_Count',
          label: 'تعداد فروش',
          align: 'center',
          field: row => row.SaleG_Count,
          sortable: true
        },
        {
          name: 'Buy_Pay',
          label: 'خرید',
          align: 'center',
          field: row => row.Buy_Pay,
          sortable: true
        },
        {
          name: 'BuyG_Count',
          label: 'تعداد خرید',
          align: 'center',
          field: row => row.BuyG_Count,
          sortable: true
        },
      ],
      items: []
    }
  },
  methods: {
    ...mapActions({
      setData: 'Products/getGoodsBuySaleMonthInCurrentYear'
    })
  },
  created() {
    this.setData({goods_Id: this.goodsInfo.Goods_ID}).then((res) => {
      this.items = res
    })
  }
}
</script>